import { ReferralNetwork, ReferralTree } from "@/modules/user/types/network";
import { apiWithAuth } from "../authApi";
import { useApplyRefcodeStore } from "../../store/applyRefcode";
import { isAxiosError } from "axios";

export const getReferralNetwork = async (): Promise<
  ReferralNetwork | undefined
> => {
  try {
    const response = await apiWithAuth.get("/referral/network");

    const answer = response.data as ReferralNetwork;

    return answer;
  } catch (error) {
    if (isAxiosError(error)) {
      const { setIsReferralError } = useApplyRefcodeStore.getState();
      type ErrorResponse = { message?: string, error?: string };
      const message =
        (error.response?.data as ErrorResponse)?.error || error.message || "";

      if (message.includes("Referral not found")) {
        setIsReferralError(true);
      }
    }
    return undefined;
  }
};

export interface GetReferralTreeParams {
  offset?: number;
  limit?: number;
  path?: string;
  filter?: string;
}

export const getReferralTree = async ({
  offset,
  limit,
  path,
  filter,
}: GetReferralTreeParams): Promise<ReferralTree | undefined> => {
  try {
    const params = new URLSearchParams();

    if (offset !== undefined) params.append("offset", offset.toString());
    if (limit !== undefined) params.append("limit", limit.toString());
    if (path) params.append("path", path);
    if (filter) params.append("filter", filter);

    const response = await apiWithAuth.get(
      `/referral/tree?${params.toString()}`
    );
    return response.data as ReferralTree;
  } catch (error) {
    return undefined;
  }
};
